module.exports = [{
      plugin: require('/Users/jbeuckman/Documents/webpage-source/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-6502690-13"},
    },{
      plugin: require('/Users/jbeuckman/Documents/webpage-source/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
